import React from 'react';
import bgImage from './bg.jpg';

export function SectionHeader() {
  return (
    <section className="relative -mt-4 py-8 sm:py-12 px-4">
      <div
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50 z-10" />
      </div>
      <div className="relative z-20 min-h-[250px] sm:min-h-[350px] max-w-7xl mx-auto px-2 sm:px-4 flex flex-col justify-center">
        <div>
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-semibold leading-tight sm:leading-[64px] inline border-b-4 sm:border-b-[7px] border-[#2f54eb] pb-3 sm:pb-5">
            SMRhub
          </h1>
        </div>
        <p className="text-white text-base sm:text-xl md:text-2xl font-normal leading-relaxed sm:leading-[38px] pt-4 sm:pt-[30px]">
          Мы – молодая стартап команда, имеющая опыт в строительной индустрии.
          <br className="hidden sm:block" />
          <br className="hidden sm:block" />
          Наша цель – реализовать цифровой проект, который упростит и ускорит
          процессы в данной отрасли. Мы работаем на результат, воплощаем наши
          идеи в жизнь и стремимся к постоянному развитию.
        </p>
      </div>
    </section>
  );
}
